// components/TonnageSelectorsBar.tsx
import React, { useMemo } from 'react';
import styled from 'styled-components';
import Select from 'react-select';
import { useTonnageStatsStore } from '../stores/tonnageStatsStore';

const Bar = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 20px 28px;
  align-items: flex-end;
  padding: 12px 16px;
  border-bottom: 1px solid #d9d9d9;
  font-size: 12px;
`;

const Field = styled.label`
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-weight: 600;
  color: #333;
`;

const NativeSelect = styled.select`
  min-width: 90px;
  padding: 4px 6px;
  border: 1px solid #cecece;
  border-radius: 2px;
  font-size: 12px;
  border-radius: 5px;
`;

const selectStyles = {
    control: (base: any) => ({ ...base, minWidth: 220, minHeight: 28, fontSize: 12 }),
    menu: (base: any) => ({ ...base, fontSize: 12, zIndex: 20 }),
};

interface Props {
    availableYears: number[];
    availableUnits: string[];
    availableAirlines: string[];
}

const WEEKS = Array.from({ length: 52 }, (_, i) => i + 1);
const MONTHS = Array.from({ length: 12 }, (_, i) => i + 1);

export function TonnageSelectorsBar({ availableYears, availableUnits, availableAirlines }: Props) {
    const {
        yearOne, yearTwo, weekOne, weekTwo, monthOne, monthTwo,
        selectedUnits, selectedAirlines,
        setYearOne, setYearTwo, setWeekOne, setWeekTwo, setMonthOne, setMonthTwo,
        setSelectedUnits, setSelectedAirlines,
    } = useTonnageStatsStore();

    const unitOptions = useMemo(() => availableUnits.map((u) => ({ value: u, label: u })), [availableUnits]);
    const airlineOptions = useMemo(() => availableAirlines.map((a) => ({ value: a, label: a })), [availableAirlines]);

    return (
        <Bar>
            <Field>
                YEAR ONE
                <NativeSelect value={yearOne} onChange={(e) => setYearOne(Number(e.target.value))}>
                    {availableYears.map((y) => <option key={y} value={y}>{y}</option>)}
                </NativeSelect>
            </Field>
            <Field>
                YEAR TWO
                <NativeSelect value={yearTwo} onChange={(e) => setYearTwo(Number(e.target.value))}>
                    {availableYears.map((y) => <option key={y} value={y}>{y}</option>)}
                </NativeSelect>
            </Field>
            <Field>
                WEEK ONE
                <NativeSelect value={weekOne} onChange={(e) => setWeekOne(Number(e.target.value))}>
                    {WEEKS.map((w) => <option key={w} value={w}>{w}</option>)}
                </NativeSelect>
            </Field>
            <Field>
                WEEK TWO
                <NativeSelect value={weekTwo} onChange={(e) => setWeekTwo(Number(e.target.value))}>
                    {WEEKS.map((w) => <option key={w} value={w}>{w}</option>)}
                </NativeSelect>
            </Field>
            <Field>
                MONTH ONE
                <NativeSelect value={monthOne} onChange={(e) => setMonthOne(Number(e.target.value))}>
                    {MONTHS.map((m) => <option key={m} value={m}>{m}</option>)}
                </NativeSelect>
            </Field>
            <Field>
                MONTH TWO
                <NativeSelect value={monthTwo} onChange={(e) => setMonthTwo(Number(e.target.value))}>
                    {MONTHS.map((m) => <option key={m} value={m}>{m}</option>)}
                </NativeSelect>
            </Field>
            <Field>
                UNITS
                <Select
                    isMulti
                    styles={selectStyles}
                    placeholder="All"
                    options={unitOptions}
                    value={unitOptions.filter((o) => selectedUnits.includes(o.value))}
                    onChange={(vals) => setSelectedUnits(vals.map((v) => v.value))}
                />
            </Field>
            <Field>
                AIRLINES
                <Select
                    isMulti
                    styles={selectStyles}
                    placeholder="All"
                    options={airlineOptions}
                    value={airlineOptions.filter((o) => selectedAirlines.includes(o.value))}
                    onChange={(vals) => setSelectedAirlines(vals.map((v) => v.value))}
                />
            </Field>
        </Bar>
    );
}